import { Component, OnInit } from '@angular/core';
import { WebTargetService } from '../../_service';
import {
  WebElement,
  WebTarger,
} from '../../_model';

@Component({
  selector: 'web-targets-list',
  template: require('./web-targets-list.component.html'),
  styles: [require('./web-targets-list.component.css')],
})

export class WebTargetsListComponent implements OnInit {

  public webTargets: WebTarger[] = [];

  public constructor(private webTargetService: WebTargetService){

  }

  public ngOnInit() {
    this.getAllWebTarget();
  }

  public getAllWebTarget(){
    this.webTargetService.getAllWebTarget().subscribe((webTargets) => {
      this.webTargets = webTargets;
    });
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/web-targets/web-targets-list/web-targets-list.component.ts